import { formatNumber, formatUSD } from "@eulerxyz/core-sdk"
import { formatUnits } from "viem"

export const formatBigIntToNumber = (
  value: string | bigint | undefined,
  decimals: number,
) => {
  if (!value) return undefined
  const formatted = formatUnits(BigInt(value), decimals)
  return formatNumber(formatted)
}

export const formatBigIntToPrice = (
  value: string | bigint | undefined,
  decimals: number,
) => {
  if (!value) return undefined
  const formatted = formatUnits(BigInt(value), decimals)
  return formatUSD(formatted)
}
